var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39,19.5A19.5,19.5,0,1,1,19.5,0,19.5,19.5,0,0,1,39,19.5Z",
    fill: "none",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17,19.63a4.23,4.23,0,1,1,4.23-4.23A4.23,4.23,0,0,1,17,19.63ZM8.64,27.94h0a8.31,8.31,0,0,1,16.62,0h0",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.47,9.89a4.16,4.16,0,0,1,1.58-.31,4.24,4.24,0,1,1,0,8.47m0,0a8.31,8.31,0,0,1,8.31,8.31h0",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.fc5fd8b3c562cf880e34198be044f883.svg";
export { ForwardRef as ReactComponent };